
<div class="l-how-to-buy-landing-page">
  <vHeroSection mode="buy" />
  <vCarouselSection />
  <vRegisterSection />
  <vSafetySection />
  <vFollowUpSection />
  <vEnjuappSection mode="buy" />
</div>
